import React from 'react';
import ToolLayout from '../components/ToolLayout';
import { User } from 'lucide-react';

/**
 * Standalone Babysitter Quick Reference tool.
 * Generate a printable quick reference card for babysitters with essential emergency info.
 */
const BabysitterReferenceTool = () => {
  return (
    <ToolLayout
      title="Babysitter Quick Reference"
      description="Make a one-page sheet with everything a babysitter needs — emergency numbers, your address, medical info, and house rules."
      icon={User}
      guide={{
        intro: 'Fill out a one-page sheet your babysitter can use in an emergency.',
        steps: [
          'Fill in your address and emergency numbers.',
          'Add parent and emergency contact info.',
          'Note any allergies, medications, or special instructions.',
          'Print it and put it somewhere easy to find.',
        ],
      }}
    >
      <div className="max-w-2xl mx-auto space-y-6">
        <p className="text-muted-foreground">
          Make a one-page sheet with emergency numbers, your address, parent contacts, and medical info.
          Print it and leave it where the babysitter can find it.
        </p>
        <p className="text-sm text-muted-foreground">
          Full quick reference generator and print coming soon. You can pull key details from your Emergency Plan.
        </p>
      </div>
    </ToolLayout>
  );
};

export default BabysitterReferenceTool;
